// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-card__label{margin-right:8px;font-weight:700;font-size:14px;line-height:18px;padding:3px 10px;color:#fff;z-index:10;background-color:var(--4srqga);border-radius:var(--13d0htc)}.media-card__label--video{background-color:var(--1rsp23a)}", ""]);
// Exports
module.exports = exports;
